<template>
    <div class="overview" v-if="customer">
        <div class="status">
            <b-card no-body class="p-3 card-secondary" v-if="customer.cjp_id">
                <p class="text-muted">This is a joint profile account.</p>
            </b-card>
            <div class="card bg-white border border-danger p-3 mb-3" v-if="!customer.ssa && !customer.sse">
                <div class="text-dark  d-flex align-items-center">
                    <i class="fa fa-exclamation-triangle text-danger mr-2"></i>
                    <div v-if="!_gHlp.customerHasAdvisoryPipeline(customer) && auth_user.account_info.is_use_advisory">
                        <span>This customer has not been assigned to any agent yet.</span> &nbsp;
                        <a href="javascript:void(0)" class="text-primary" @click="$emit('toggleAssignModal')">Send to Advisory</a>
                    </div>
                    <div v-else>
                        <span>This customer is pending assign to advisor.</span> &nbsp;
                        <a href="javascript:void(0)" class="text-primary" v-if="auth_user && _gHlp.checkRoleType( ['admin', 'manager', 'director','corporate'])" @click="$emit('toggleAssignModal')">Assign Now</a>
                    </div>
                </div>
            </div>
            <b-card no-body class="p-3 card-secondary" :style="{'border': '1px solid '+BASKET_COLOR[customer.basket.basket_color]}" v-if="checkIsCorporateSubscription() && !customer.cjp_id">
                <b-card-header class="p-0 pb-2">
                    <b-row>
                        <b-col cols="12" class="d-flex align-items-center">
                            <b-iconstack font-scale="1.7" class="mr-2">
                                <b-icon stacked icon="square-fill" :style="{'color':BASKET_COLOR[customer.basket.basket_color]}"></b-icon>
                                <b-icon stacked icon="basket2" scale="0.5" class="text-white"></b-icon>
                            </b-iconstack>
                            <p class="font-weight-bolder" :style="{'color':BASKET_COLOR[customer.basket.basket_color]}">{{ customer.basket.basket_color }} Basket</p>
                        </b-col>
                    </b-row>
                </b-card-header>
                <b-row>
                    <b-col cols="12" class="pt-2" v-if="basketCause.length > 0">
                        <ul>
                            <li v-for="(itm, index) in basketCause" :key="index">
                                <b>{{ itm.stage_title  }}</b> <i class='fa fa-circle' :style="{color:itm.stage_color}"></i> {{ itm.stage_input_technical }} 
                            </li>
                        </ul>
                    </b-col>
                </b-row>
            </b-card>
        </div>
        <div class="timeline" v-if="!customer.cjp_id">
            <b-card no-body class="pt-4 pb-1">
                <div class="block">
                    <el-timeline>
                        <el-timeline-item
                            v-for="(activity, index) in activities"
                            :key="index"
                            :icon="activity.icon"
                            :type="activity.type"
                            :color="activity.color"
                            :size="activity.size"
                            :timestamp="activity.timestamp"
                        >
                            {{activity.content}}
                        </el-timeline-item>
                    </el-timeline>
                </div>
            </b-card>
        </div>
        <div v-if="!customer.cjp_id">
            <CustomerActivityLog :customer="customer"/>
        </div>
    </div>
</template>
<script>
    import { Card, Button, Tag, Timeline, TimelineItem } from 'element-ui'
    import {BASKET_COLOR} from '@/assets/js/colors.js'
    import { mapState } from 'pinia'
    import { useCustomerStore } from '@/stores/customerStore'
    import { useAuthStore } from '@/stores/authStore'
    import helperFunctionMixin from '@/assets/js/helperFunctionMixin'
    import moment from 'moment'
    import { CAN_ASSIGN_ROLE_IDS } from '@/assets/js/roles.js' 
    import CustomerActivityLog from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/CustomerActivityLog'

    export default {
        props: ['customer'],
        name: 'overview',
        mixins: [helperFunctionMixin],
        components: {
            CustomerActivityLog,
            [Card.name]: Card,
            [Button.name]: Button,
            [Tag.name]: Tag,
            [Timeline.name]: Timeline,
            [TimelineItem.name]: TimelineItem,
        },
        computed: {
            ...mapState(useCustomerStore, ['current_commitment']),
            ...mapState(useAuthStore, ['auth_user']),
            basketCause() {
                if (this.customer?.basket?.basket_raw_json?.basket_json) {
                    const baket_json = this.customer?.basket?.basket_raw_json?.basket_json
                    return baket_json.filter(item => item.stage_risk > 1).sort((a, b) => b.stage_risk - a.stage_risk)

                }
                return []
            },
            activities(){
                return  [
                    {
                        content: 'Profile',
                        timestamp: 'Profile information has been filled out.',
                        size: 'large',
                        color: this.customer.checklist.has_filled_profile ? '#0bc196' : '',
                        icon: this.customer.checklist.has_filled_profile ? 'el-icon-check' : ''
                    }, 
                    {
                        content: 'Net Income',
                        timestamp: 'Net income has been filled out.',
                        size: 'large',
                        color: this.customer.checklist.has_net_income ? '#0bc196' : '',
                        icon: this.customer.checklist.has_net_income ? 'el-icon-check' : ''
                    }, 
                    {
                        content: 'Commitment',
                        timestamp: this.current_commitment ? 
                            'Latest Credit Report has been generated on '+ moment(this.current_commitment.credit_report_response_datetime).format('D MMM, YYYY h:mm A') : ''
                        ,
                        color: this.current_commitment ? '#0bc196' : '',
                        icon: this.current_commitment ? 'el-icon-check' : '',
                        size: 'large',
                        // color: '#0bc196',
                    }, 
                    // {
                    //     content: 'Proposal',
                    //     timestamp: 'Total 5 proposal in progress',
                    //     size: 'large',
                    //     // color: '#0bc196',
                    // },
                    // {
                    //     content: 'Cases',
                    //     // timestamp: 'Create Case',
                    //     size: 'large',
                    //     // color: '#0bc196',
                    // }
                ]
            }
        },
        data() {            
            return {
                BASKET_COLOR:BASKET_COLOR,
                CAN_ASSIGN_ROLE_IDS: CAN_ASSIGN_ROLE_IDS,
            };
        }
    }
</script>